import { UserCommunication } from '@this+that/models';

import { ShortcutContext } from './types';
import { useEmailListNavigation } from './useEmailListNavigation';

interface UseSnoozedNavigationProps {
  filteredCommunications: UserCommunication[];
}

export function useSnoozedNavigation({
  filteredCommunications,
}: UseSnoozedNavigationProps) {
  return useEmailListNavigation({
    filteredCommunications,
    context: ShortcutContext.SNOOZED,
  });
}
